module.exports = __webpack_public_path__ + "./assets/icons__0ab54153eeeca0ce03978cc463b257f7.woff2";